/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-sample-item.reducer';

export const DiaglabSampleItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabSampleItemEntity = useAppSelector(state => state.diaglabSampleItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabSampleItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.detail.title">DiaglabSampleItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.id}</dd>
          <dt>
            <span id="itemAccessionNo">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.itemAccessionNo">Item Accession No</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.itemAccessionNo}</dd>
          <dt>
            <span id="referredToOrFrom">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.referredToOrFrom">Referred To Or From</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.referredToOrFrom}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.quantity}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.timestampEntry}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.status">Status</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.status}</dd>
          <dt>
            <span id="typeOfSample">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.typeOfSample">Type Of Sample</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.typeOfSample}</dd>
          <dt>
            <span id="testSquence">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.testSquence">Test Squence</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.testSquence}</dd>
          <dt>
            <span id="rejectReason">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.rejectReason">Reject Reason</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.rejectReason}</dd>
          <dt>
            <span id="uom">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.uom">Uom</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.uom}</dd>
          <dt>
            <span id="collectionDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.collectionDate">Collection Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.collectionDate}</dd>
          <dt>
            <span id="enteredDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.enteredDate">Entered Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.enteredDate}</dd>
          <dt>
            <span id="sendingdDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.sendingdDate">Sendingd Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.sendingdDate}</dd>
          <dt>
            <span id="receivedDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.receivedDate">Received Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.receivedDate}</dd>
          <dt>
            <span id="acceptingDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.acceptingDate">Accepting Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.acceptingDate}</dd>
          <dt>
            <span id="precessingDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.precessingDate">Precessing Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.precessingDate}</dd>
          <dt>
            <span id="completionDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.completionDate">Completion Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.completionDate}</dd>
          <dt>
            <span id="verificationDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.verificationDate">Verification Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.verificationDate}</dd>
          <dt>
            <span id="authenticationDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.authenticationDate">Authentication Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.authenticationDate}</dd>
          <dt>
            <span id="releasedDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.releasedDate">Released Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.releasedDate}</dd>
          <dt>
            <span id="transmissionDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.transmissionDate">Transmission Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemEntity.transmissionDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.sample">Sample</Translate>
          </dt>
          <dd>{diaglabSampleItemEntity.sample ? diaglabSampleItemEntity.sample.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.labTestItem">Lab Test Item</Translate>
          </dt>
          <dd>{diaglabSampleItemEntity.labTestItem ? diaglabSampleItemEntity.labTestItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.collector">Collector</Translate>
          </dt>
          <dd>{diaglabSampleItemEntity.collector ? diaglabSampleItemEntity.collector.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-sample-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-sample-item/${diaglabSampleItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabSampleItemDetail;
